<template>
    <div class="vld-parent">
        <loading :active.sync="bool_fullLoading" :is-full-page="bool_fullScreen"></loading>
        <!-- Edit Pop up Modal -->
        <div v-if="bool_isAMV">
            <transition name="modal-fade">
                <div class="modal-backdrop" margin="auto">
                    <div style="width:55%">
                        <CCard>
                            <CCardBody class="modal-body">
                                <!-- Modal Title -->
                                <CRow>
                                    <CCol col="8">
                                        <h4 id="traffic" class="card-title mb-0">{{this.getLanguage["CR"][obj_currency.I > 0? "EC": "AC"]}}</h4>
                                    </CCol>
                                    <CCol col="4">
                                        <CButton id="btn-close1" class="float-right"
                                                 @click="closeAdd()">
                                            <CIcon name=cilX></CIcon>
                                        </CButton>
                                    </CCol>
                                </CRow>
                                <div class='subHeaderHR'></div>
                                <!-- Modal Body -->
                                <CRow>
                                    <CCol col="6">
                                        <label class="col-form-label-sm">{{this.getLanguage["CPR"]["BM"]}}<span class="required" /> :</label>
                                        <CInput type="text"
                                                size="sm"
                                                vertical
                                                :placeholder="this.getLanguage['CPR']['BM']"
                                                :value="formattedBM"
                                                :disabled="obj_currency.CI > 0"
                                                ref="BM"></CInput>
                                    </CCol>
                                </CRow>
                                <CRow>
                                    <CCol col="6">
                                        <label class="col-form-label-sm">{{this.getLanguage["CR"]["CN"]}}<span class="required" /> :</label>
                                        <CInput type="text"
                                                size="sm"
                                                vertical
                                                :placeholder="this.getLanguage['CR']['CN']"
                                                :value="obj_currency.CN"
                                                @change="v => obj_currency.CN = v"
                                                ref="CN"></CInput>
                                        <span class="ErrMsg">{{ ValidationErrMsg('CN','CN') }}</span>
                                    </CCol>
                                    <CCol col="6">
                                        <label class="col-form-label-sm">{{this.getLanguage["CR"]["CC"]}}<span class="required" /> :</label>
                                        <CInput type="text"
                                                size="sm"
                                                vertical
                                                :placeholder="this.getLanguage['CR']['CC']"
                                                :value="obj_currency.ISOC"
                                                :disabled="obj_currency.CI > 0"
                                                @change="v => obj_currency.ISOC = v"
                                                ref="ISOC"></CInput>
                                        <span class="ErrMsg">{{ ValidationErrMsg('ISOC','CC') }}</span>
                                    </CCol>
                                </CRow>
                                <CRow>
                                    <CCol col="6">
                                        <label class="col-form-label-sm">{{this.getLanguage["CR"]["CS"]}}<span class="required" /> :</label>
                                        <CInput type="text"
                                                size="sm"
                                                vertical
                                                :placeholder="this.getLanguage['CR']['CS']"
                                                :value="obj_currency.CS"
                                                @change="v => obj_currency.CS = v"
                                                ref="CS"></CInput>
                                        <span class="ErrMsg">{{ ValidationErrMsg('CS','CS') }}</span>
                                    </CCol>
                                    <CCol col="6">
                                        <label class="col-form-label-sm">{{this.getLanguage["CR"]["CR"]}}<span class="required" /> :</label>
                                        <CInput type="number"
                                                size="sm"
                                                vertical
                                                :placeholder="this.getLanguage['CR']['CR']"
                                                :value="obj_currency.ER"
                                                @change="v => obj_currency.ER = v"
                                                ref="ER"></CInput>
                                        <span class="ErrMsg">{{ ValidationErrMsg('ER','CR') }}</span>
                                    </CCol>
                                </CRow>
                                <CRow>
                                    <CCol col="6">
                                        <div style="margin-bottom:20px">
                                            <label class="col-form-label-sm">{{getLanguage["CR"]["TS"]}}</label>
                                            <treeselect :multiple="false"
                                                        :options="arry_Separator"
                                                        :clearable="false"
                                                        v-model="obj_currency['TS']" />
                                        </div>
                                    </CCol>

                                    <CCol col="6">
                                        <div style="margin-bottom:20px">
                                            <label class="col-form-label-sm">{{getLanguage["CR"]["DS"]}}</label>
                                            <treeselect :multiple="false"
                                                        :options="arry_Separator"
                                                        :clearable="false"
                                                        v-model="obj_currency['DS']" />
                                        </div>
                                    </CCol>
                                </CRow>
                                <div style="text-align:center;margin-top:20px">
                                    <CButton color="outline-info" size="sm" @click="saveCurrency()">
                                        <span class='plusIcon cil-plus'></span>
                                        {{this.getLanguage["BTN"]["SV"]}}
                                    </CButton>
                                </div>
                                <label class="mandatory_Field">{{this.getLanguage['MANDATORY']['FIELDS']}}</label>
                            </CCardBody>
                        </CCard>
                    </div>
                </div>
            </transition>
        </div>

        <!-- Body -->
        <div class="container-fluid">
            <CRow>
                <CCol>
                    <!-- Page Title -->
                    <div class='pageHeader'>
                        <h2 id="titleHeight">{{this.getLanguage["RCS"]["TIT"]}} </h2>
                    </div>
                    <!-- Search Form -->
                    <div class="searchForm" v-show="bool_showSearchBar">
                        <div class='searchBox'>
                            <div class='searchCol'>
                                <span class='searchLabel'>{{this.getLanguage["CPR"]["BM"]}} :</span>
                                <vue-monthly-picker v-model="str_FV[0].FV"
                                                    :clearOption="false"
                                                    selectedBackgroundColor="blue">
                                </vue-monthly-picker>
                            </div>
                        </div>
                        <div class='searchBtnCol'>
                            <CButton v-shortkey="['enter']" @shortkey="newSearch()" ref="search" class='searchBtn' size="sm" block color="success" @click=" newSearch()"><span class='searchIcon cil-search'></span><span>{{this.getLanguage["BTN"]["SR"]}}</span></CButton>
                        </div>
                    </div>
                </CCol>
            </CRow>

            <div class='table-wrapper'>
                <!-- Table Title -->
                <header class="table-header">
                    <strong> {{this.getLanguage["RCS"]["TIT"]}} </strong>
                    <div class="pageBtn">
                        <button @click="ctrPage(+int_Page - 1)">
                            <span class="arrowLeft"></span>
                        </button>
                        <input class="page-control"
                               v-model="int_Page"
                               type="number"
                               v-shortkey.avoid
                               @keyup="ctrPage(+int_Page,0)" />
                        <span class="tableItemCount">/ {{int_TP}}</span>
                        <button @click="ctrPage(+int_Page + 1)">
                            <span class="arrowRight"></span>
                        </button>
                    </div>
                </header>
                <!-- Table Header for Fixed Display -->
                <div class="custom-table-wrapper" id="tHead">
                    <table class='custom-table afb-blue'>
                        <thead>
                            <tr>
                                <th>{{getLanguage["CR"]["ID"]}}</th>
                                <th v-if="(checkModuleAccess2(constAccessType.edit) || checkModuleAccess2(constAccessType.delete)) && checkAgentAccess() && bool_showActionStatus">
                                    {{getLanguage["GL"]["ACT"]}}
                                </th>
                                <th v-if="checkModuleAccess2(constAccessType.add) && checkAgentAccess() && bool_showActionStatus">
                                    {{getLanguage["CR"]["S"]}}
                                </th>
                                <th>
                                    {{getLanguage["CPR"]["BM"]}}
                                </th>
                                <th>
                                    {{getLanguage["CR"]["CN"]}}
                                    <i @click="setSortTable('CN')" :class="['sortlogo', setSortLogo('CN')]"></i>
                                </th>
                                <th>
                                    {{getLanguage["CR"]["CC"]}}
                                    <i @click="setSortTable('ER')" :class="['sortlogo', setSortLogo('ER')]"></i>
                                </th>
                                <th>{{getLanguage["CR"]["CR"]}}</th>
                                <th>{{getLanguage["CR"]["CB"]}}</th>
                                <th>
                                    {{getLanguage["CR"]["CT"]}}
                                    <i @click="setSortTable('CTS')" :class="['sortlogo', setSortLogo('CTS')]"></i>
                                </th>
                                <th>{{getLanguage["CR"]["UB"]}}</th>
                                <th>
                                    {{getLanguage["CR"]["UTS"]}}
                                    <i @click="setSortTable('UTS')" :class="['sortlogo', setSortLogo('UTS')]"></i>
                                </th>
                                <th>{{getLanguage["CR"]["TS"]}}</th>
                                <th>{{getLanguage["CR"]["DS"]}}</th>
                            </tr>
                        </thead>
                    </table>
                </div>
                <!-- Table Body -->
                <div class="custom-table-wrapper" id="tBody">
                    <table class='custom-table afb-blue'>
                        <!-- Hidden Table Header for Parallel Scrolling -->
                        <thead>
                            <tr>
                                <th>{{getLanguage["CR"]["ID"]}}</th>
                                <th v-if="(checkModuleAccess2(constAccessType.edit) || checkModuleAccess2(constAccessType.delete)) && checkAgentAccess() && bool_showActionStatus">
                                    {{getLanguage["GL"]["ACT"]}}
                                </th>
                                <th v-if="checkModuleAccess2(constAccessType.add) && checkAgentAccess() && bool_showActionStatus">
                                    {{getLanguage["CR"]["S"]}}
                                </th>
                                <th>
                                    {{this.getLanguage["CPR"]["BM"]}}
                                </th>
                                <th>
                                    {{getLanguage["CR"]["CN"]}}
                                    <i @click="setSortTable('CN')" :class="['sortlogo', setSortLogo('CN')]"></i>
                                </th>
                                <th>
                                    {{getLanguage["CR"]["CC"]}}
                                    <i @click="setSortTable('ER')" :class="['sortlogo', setSortLogo('ER')]"></i>
                                </th>
                                <th>{{getLanguage["CR"]["CR"]}}</th>
                                <th>{{getLanguage["CR"]["CB"]}}</th>
                                <th>
                                    {{getLanguage["CR"]["CT"]}}
                                    <i @click="setSortTable('CTS')" :class="['sortlogo', setSortLogo('CTS')]"></i>
                                </th>
                                <th>{{getLanguage["CR"]["UB"]}}</th>
                                <th>
                                    {{getLanguage["CR"]["UTS"]}}
                                    <i @click="setSortTable('UTS')" :class="['sortlogo', setSortLogo('UTS')]"></i>
                                </th>
                                <th>{{getLanguage["CR"]["TS"]}}</th>
                                <th>{{getLanguage["CR"]["DS"]}}</th>
                            </tr>
                        </thead>
                        <!-- Table Body Data -->
                        <tbody>
                        <td v-if="arry_cl.length == 0" colspan="100%">{{ this.getLanguage['GL']['NR'] }}</td> <!-- Span total columns of the table -->
                        <tr v-for="(data,index) in arry_cl" v-bind:key="index">
                            <td>{{ CountItem(index+1)}}</td>
                            <td v-if="(checkModuleAccess2(constAccessType.edit) || checkModuleAccess2(constAccessType.delete)) && checkAgentAccess() && checkBMDate(data.BM)">
                                <div id="actionBtnCol">
                                    <div v-if="checkModuleAccess2(constAccessType.edit)" class="custom-tooltip">
                                        <i class="cil-color-border ActionBtn" @click='editCurrency(data.CI, data.BM)'></i>
                                        <span class="custom-tooltiptext">{{getLanguage["BTN"]["ED"]}}</span>
                                    </div>
                                </div>
                            </td>
                            <td v-if="checkModuleAccess2(constAccessType.add) && checkAgentAccess() && checkBMDate(data.BM)">
                                <label class="switch">
                                    <input type="checkbox" @click="changeStatus(data.CI, data.BM,data.RS)" :checked="checkStatus(data.RS)">
                                    <span class="slider round" :class="bool_statusLock?'STYLE_lock':'STYLE_unlock'"></span>
                                </label>
                            </td>
                            <td>{{ formatDateTime(data.BM, "YYYY-MM-DD HH:mm:ss", "MMM YYYY") }}</td>
                            <td>{{ data.CN }}</td>
                            <td>{{ data.ISOC }} ({{ data.CS }})</td>
                            <td>{{ data.ER }}</td>
                            <td>{{ data.CB }}</td>
                            <td>{{ formatDateTime(data.CTS, "YYYY-MM-DD HH:mm:ss", "DD MMM YYYY HH:mm:ss") }}</td>
                            <td>{{ data.UB }}</td>
                            <td>{{ formatDateTime(data.UTS, "YYYY-MM-DD HH:mm:ss", "DD MMM YYYY HH:mm:ss") }}</td>
                            <td>{{ data.TS }}</td>
                            <td>{{ data.DS }}</td>
                        </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import { constAccessType, loadingFullScreen } from '@/modules/Constant.js';
    import genericHelper from "@/modules/GenericHelper.js";
    import Loading from 'vue-loading-overlay';
    import VueMonthlyPicker from 'vue-monthly-picker';
    import Treeselect from '@riophae/vue-treeselect'
    import { mapGetters, mapActions } from 'vuex'
    import moment from "moment";
    import $ from 'jquery'
    import { required } from 'vuelidate/lib/validators';

    export default {
        mixins: [genericHelper],
        components: {
            VueMonthlyPicker,
            Treeselect,
            Loading
        },
        computed: {
            ...mapGetters('Language', ['getLanguage']),
            ...mapGetters('UserInfo', ['getUserInfo', 'checkModuleAccess']),
            formattedBM() {
                return this.formatDateTime(this.obj_currency.BM, "YYYY-MM-DD HH:mm:ss", "MMM YYYY");
            },
        },
        data() {
            return {
                bool_isAMV: false, // Add Modal Visible
                bool_fullLoading: false,
                bool_fullScreen: loadingFullScreen, //Full Screen
                bool_CV: false, // Check Validation
                bool_showSearchBar: true,

                //the parameter of getList()
                int_Page: 1,//current Page
                int_IC: 1, // Item Count
                int_RC: 100, //Row Count
                str_tableSortBy: "", //(sort the table col name)
                bool_isSort: false, // Table Ascending Descending
                str_FV: [
                    { F: "BM", FV: moment(new Date(new Date().getFullYear(), new Date().getMonth())) }, // By Month
                ], //Filter Value

                //ctrl Page valuev (A return Data )
                int_TI: 0,//Total Items
                int_TP: 1, //Total Page
                constAccessType: constAccessType,

                //array hold data
                arry_Separator: [{ id: ',', label: 'Comma (,)' }, { id: '.', label: 'Period (.)' }],
                obj_currency: {
                    "I": 0,
                    "RS": 1,
                    "TS": ",",
                    "DS": ".",
                    "CN": null,
                    "ISOC": null,
                    "CS": null,
                    "ER": null,
                    "BM": "",
                    "CurrencyId": 0,
                },
                arry_cl: [], //Currency List
                agentWithAccessList: [], // Agent with access list

                // Action & Status Column view
                bool_showActionStatus: true,
            }
        },
        methods: {
            closeAdd() {
                this.bool_isAMV = !this.bool_isAMV;
                this.bool_CV = false;
            },
            checkModuleAccess2(type) {
                return this.checkModuleAccess('RCS', 'B', type);
            },
            getAgentAccessList() {
                this.getDataApi(`/api/reports/getAgentWithAccess`, (d, s) => {
                    if (s) {
                        this.agentWithAccessList = d;
                    }
                });
            },
            checkAgentAccess() {
                // Make sure agentWithAccessList is loaded.
                if (!this.agentWithAccessList || !this.agentWithAccessList.length) {
                    return false;
                }
                const currentUserAgentId = this.getUserInfo.AID;
                const currentUserAgentGroupId = this.getUserInfo.AGI;
                // Loop through the list and check for a match.
                for (let i = 0; i < this.agentWithAccessList.length; i++) {
                    const agent = this.agentWithAccessList[i];
                    // Return TRUE if matched current user with Agent in List.
                    if (agent.I === currentUserAgentId && agent.AGI === currentUserAgentGroupId) {
                        return true;
                    }
                }
                return false; // Return false if no agent matched
            },
            checkStatus(RS) {
                return this.$parent.checkStatus(RS);
            },
            CountItem(value) {
                if (this.int_IC != 1) {
                    return value + ((this.int_IC - 1) * this.int_RC);
                }
                else {
                    return value;
                }
            },
            ctrPage(newPage,inputValue = 1) {
                if (inputValue == 0) {
                    this.int_Page = Math.max(1, Math.min(newPage, this.int_TP));
                }
                else {
                    this.int_Page = (newPage > this.int_TP) ? 1 : (newPage < 1) ? this.int_TP : newPage;
                }
                this.int_IC = this.int_Page;
                this.getCurrencyList();
            },
            changeLock() {
                if (this.bool_statusLock) {
                    this.$fire({
                        title: this.getLanguage["GL"]["CM"],
                        width: '30em',
                        showCancelButton: true,
                        confirmButtonText: this.getLanguage["GL"]["YES"],
                        cancelButtonText: this.getLanguage["CNO"]["NO"],
                        reverseButtons: true,
                        customClass: {
                            title: 'afb-alert-title',
                            content: 'afb-alert-content',
                            actions: 'afb-alert-action'
                        }
                    }).then((result) => {
                        if (result.value == true) {
                            this.bool_statusLock = !this.bool_statusLock
                        }
                    });
                } else if (this.bool_statusLock == false) {
                    this.bool_statusLock = !this.bool_statusLock
                }
            },
            changeStatus(currencyId, byMonth, status) {
                this.bool_fullLoading = true;
                this.bool_fullScreen = true;
                var that = this;
                //if (confirm("Are you sure you want to Change?")) {
                status = status == 2 ? 1 : 2;
                this.getDataApi(`/api/reports/gch/${currencyId}?byMonth=${encodeURIComponent(byMonth)}`,
                    function (d, s) {
                        that.bool_fullLoading = false;
                        that.bool_fullScreen = false;
                        if (s) {
                            that.obj_currency = d.D;
                            that.obj_currency["RS"] = status;
                            that.saveCurrency();
                        }
                    });
            },
            getCurrencyList() {
                this.bool_fullLoading = true;
                var that = this;
                var path = this.getListingParamQuery(this.int_Page, this.int_RC, this.str_tableSortBy, this.bool_isSort);
                // Map the Filter Values to path
                for (var i = 0; i < this.str_FV.length; i++) {
                    if (this.str_FV[i].F == 'BM' && this.str_FV[i].FV != '') { // By Month
                        var by_month = this.parseDateToJsonString(this.str_FV[i].FV);
                        path += "&f[BM]=" + by_month; // Add Filter value to path
                    }
                }
                
                this.getDataApi(`/api/reports/lch?${path}`,
                    function (d, s) {
                        that.bool_fullLoading = false;
                        if (s) {
                            that.setCurrencyList(d);
                            that.resizeTableHead();
                        }
                    });
            },
            saveCurrency() {
                this.bool_CV = true;
                this.$v.obj_currency.$touch();
                if (!this.$v.obj_currency.$error) {
                    this.bool_fullLoading = true;
                    this.bool_fullScreen = true;
                    var that = this;
                    this.postDataApi(`/api/reports/sch`, this.obj_currency,
                        function (d, s) {
                            that.bool_fullLoading = false;
                            that.bool_fullScreen = false;
                            if (s) {
                                that.bool_isAMV = false;
                                that.getCurrencyList();
                            }
                        });
                } else {
                    //get the object for validating.
                    const validation = this.$v["obj_currency"];
                    if (!validation) {
                        return;
                    }

                    const input = this.findRequiredInput(validation, this.$refs);
                    if (!input || typeof input.focus !== "function") {
                        return;
                    }

                    input.focus();
                }
            },
            editCurrency(currencyId, byMonth) {
                this.bool_fullLoading = true;
                var that = this;
                this.getDataApi(`/api/reports/gch/${currencyId}?byMonth=${encodeURIComponent(byMonth)}`,
                    function (d, s) {
                        that.bool_fullLoading = false;
                        if (s) {
                            that.setCurrency(d.D);
                        }
                    });
            },
            setCurrency(data) {
                this.obj_currency = Object.assign(this.obj_currency, data);
                this.bool_isAMV = true;
            },
            setCurrencyList(returnD) {   // this out put at Currency.js and this output after get list
                var data = returnD.D;
                this.arry_cl = data.Items;
                this.int_TP = Math.max(data.TotalPages, 1);                
                this.int_TI = data.TotalItems;
            },
            setSortTable(SV) { //SV = Sort Value
                this.int_Page = 1;
                this.int_IC = 1;
                this.str_tableSortBy = SV;
                this.bool_isSort = !this.bool_isSort;//change Ascending or Descending ,and then goto the {watch:/bool_isSort}
                this.getCurrencyList();
            },
            setSortLogo(str_TF) {
                return `cil-${this.str_tableSortBy == str_TF ? (this.bool_isSort ? 'sort-descending' : 'sort-ascending') : 'list'}`;//here change the sort logo
            },
            resizeTableHead() {
                this.initTableObserver();
                // Set up scroll synchronization
                const header = this.$el.querySelector("#tHead");
                const body = this.$el.querySelector("#tBody");

                header.addEventListener("scroll", () => {
                    body.scrollLeft = header.scrollLeft;
                });

                body.addEventListener("scroll", () => {
                    header.scrollLeft = body.scrollLeft;
                });
            },
            calculateWidths() {
                $('#tHead, #tBody').scrollLeft(0);
                const tables = this.$el.querySelectorAll('#tBody .custom-table');
                const headerCells = this.$el.querySelectorAll('#tHead .custom-table thead tr:nth-child(1) th');

                if (!headerCells.length) return;

                tables.forEach((table) => {
                    const bodyCells = table.querySelectorAll('tbody tr:first-child td');
                    if (!bodyCells.length) return;

                    // Reset all widths
                    [...headerCells, ...table.querySelectorAll('tbody tr td')].forEach(cell => cell.style.width = '');

                    // Apply new widths
                    bodyCells.forEach((cell, index) => {
                        const width = `${cell.getBoundingClientRect().width}px`;
                        if (headerCells[index]) headerCells[index].style.width = width;
                        table.querySelectorAll(`tbody tr td:nth-child(${index + 1}):not(td table td)`).forEach(td => td.style.width = width);
                    });
                });
            },
            initTableObserver() {
                const bodyTable = this.$el.querySelector('#tBody');

                // Observe changes in the body table
                const observer = new MutationObserver(() => {
                    this.calculateWidths(); // Recalculate widths when rows change
                });

                observer.observe(bodyTable, { childList: true, subtree: true });
                this.calculateWidths();
            },
            ValidationErrMsg(value, langKey = "") {
                if (this.bool_CV) {
                    var validateObj = this.$v.obj_currency[value];
                    if (validateObj.required != undefined && !validateObj.required) {
                        return String.format(this.utilGetErrorLanguage('1001'), this.getLanguage["CR"][langKey]);
                    }
                }
            },
            checkBMDate(BM) {
                const bmDate = new Date(BM);
                const now = new Date();
                const currentYear = now.getFullYear();
                const currentMonth = now.getMonth(); // 0-based index
                const currentDay = now.getDate();
                const lastDay = new Date(currentYear, currentMonth + 1, 0).getDate();
                // Check if BM is in the current month
                const isCurrentMonth = bmDate.getFullYear() === currentYear && bmDate.getMonth() === currentMonth;
                // Check if today is in the last 3 days of the current month
                const isTodayLast3Days = currentDay >= lastDay - 2 && currentDay <= lastDay;
                // Check if BM is in the last 3 days of the current month
                const isLast3Days =
                    isCurrentMonth && bmDate.getDate() >= lastDay - 2 && bmDate.getDate() <= lastDay;
                // Check if BM is in the next month
                const isNextMonth = bmDate.getFullYear() === currentYear && bmDate.getMonth() === currentMonth + 1;
                if (isCurrentMonth) {
                    this.bool_showActionStatus = !isTodayLast3Days;
                    return !isTodayLast3Days; // Return true if not in the last 3 days, false otherwise
                }
                if (isNextMonth && isTodayLast3Days) {
                    this.bool_showActionStatus = true;
                    return true; // BM is next month and today is in the last 3 days of the current month
                }

                this.bool_showActionStatus = false;
                return false; // Default case
            },
            newSearch() {
                if (!this.bool_isAMV && (this.str_FV[0].FV)) {
                    this.$refs.search.focus();
                    this.int_Page = 1;
                    this.int_IC = 1;

                    this.getCurrencyList();
                }
            },
        },
        created() {
            this.$parent.showSubMenu = 'B';
            this.$parent.showActiveMenu = 'B.RCS';
            this.getCurrencyList();
            this.getAgentAccessList();
        },
        watch: {
            bool_isAMV() {
                if (!this.bool_isAMV && this.bool_CV) {
                    this.showSuccessMessage(this.utilGetErrorLanguage("ERR.SS"), this.utilGetErrorLanguage("GL.AS"));
                }
            },
            getLanguage() {
                this.getCurrencyList();
            },
        },
        validations: {
            obj_currency: {
                CN: { required },
                ISOC: { required },
                CS: { required },
                ER: { required },
            }
        },
    }

</script>



// WEBPACK FOOTER //
// src/components/SideMenu/Banks/ReportCurrencySetting.vue